import { render, staticRenderFns } from "./AdminThemes.vue?vue&type=template&id=0ea54ab2&scoped=true"
import script from "./AdminThemes.vue?vue&type=script&lang=js"
export * from "./AdminThemes.vue?vue&type=script&lang=js"
import style0 from "./AdminThemes.vue?vue&type=style&index=0&id=0ea54ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea54ab2",
  null
  
)

export default component.exports